import React from 'react'
import About from '../Components/about/About'
import Footer from '../Components/footer/Footer'

function AboutComponent() {
    return (
        <>
            <About />
            <Footer />
        </>
    )
}
export default AboutComponent